import { EDealType } from '../../../../types/dealType';
import { FDealType, FOfferType } from '../../../../utils/category';
import { getMessageKeyParameter } from './getMessageKeyParameter';

export const getUrlWithParams = (url: string, serpType: FDealType, offerType: FOfferType) => {
  const messageKey = getMessageKeyParameter(offerType, serpType);

  switch (serpType) {
    case EDealType.RentDaily:
      return `${url}?cian_source=listing_banner&search_category=dailyRent&message_key=${messageKey}`;

    case EDealType.Rent:
      return `${url}?cian_source=listing_banner&search_category=rent&message_key=${messageKey}`;

    case EDealType.Sale:
      return `${url}?cian_source=listing_banner&search_category=sale&message_key=${messageKey}`;

    default:
      return `${url}?cian_source=listing_banner&message_key=${messageKey}`;
  }
};
